export const TAGS_ACTIONS: Record<string, string> = [
  'GET_TAGS',
  'CREATE_TAG',
  'UPDATE_TAG',
  'DELETE_TAG'
].reduce((acc, a) => ({ ...acc, [a]: `TAGS/${a}` }), {});
